module.exports = __webpack_public_path__ + "img/circle-two.214f2eb7.svg";